var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActivityBlueIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 107,
    viewBox: "0 0 98 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.0667 8.27361C12.6667 12.8069 2.66666 17.0736 2.66666 17.8736C2.66666 19.7403 45.2 42.5403 48.6667 42.5403C52.2667 42.5403 94.6667 19.7403 94.6667 17.8736C94.6667 16.6736 50.1333 -0.393051 48 0.00694656C47.6 0.00694656 37.3333 3.74028 25.0667 8.27361ZM86.8 17.7403C86.8 18.4069 78.4 23.4736 68 28.9403C50.6667 38.0069 48.6667 38.6736 45.4667 37.2069C42.1333 35.6069 42.6667 35.2069 61.3333 25.7403C78.8 16.8069 86.6667 14.4069 86.8 17.7403Z",
    fill: "#1675FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.933333 24.6736C0.4 25.207 0 36.6736 0 50.007V74.407L5.73333 78.9403C18.9333 89.4736 42.9333 105.34 44.8 104.674C46.2667 104.14 46.6667 99.207 46.6667 77.8736C46.6667 63.0736 46.1333 50.6736 45.3333 49.207C44.6667 47.8736 34.9333 41.7403 23.7333 35.607C-0.4 22.407 2 23.607 0.933333 24.6736Z",
    fill: "#1675FA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3334 35.7403L52.6667 47.3403L52.2667 76.9403C52.1334 93.2069 52.2667 106.54 52.8 106.54C53.2 106.54 63.0667 99.6069 74.8 91.0736C88 81.4736 96.2667 74.5403 96.6667 72.8069C98 67.6069 96.8 24.8069 95.3334 24.4069C94.6667 24.2736 84.6667 29.3403 73.3334 35.7403Z",
    fill: "#1675FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityBlueIcon);
export default __webpack_public_path__ + "static/media/activity-blue-icon.393ba12e470dcdabf116201bf714207f.svg";
export { ForwardRef as ReactComponent };